module.exports = __webpack_public_path__ + "static/media/Discover.be04bff3.svg";